export const i18n_en = {
    product: "Sản phẩm",
    letushelp: "Hãy để chúng tôi giúp bạn",
    registerForFreeSupport: "Đăng ký thông tin tại đây để nhận tư vấn miễn phí",
    fullname: "Họ và tên",
    prePhone: "Mã số điện thoại",
    phoneNumber: "Số điện thoại",
    email: "Email",
    customerPHLAlready: "Tôi đã là khách hàng của Phú Hưng Life",
    interestInPHL: "Tôi đang quan tâm sản phẩm/ dịch vụ Phú Hưng Life",
    poNumber: "Số hợp đồng bảo hiểm",
};

